import React, {Component} from "react";
import {PropTypes} from "prop-types";
import ClaimsTable from "./ClaimsTable";
import * as messageConstants from "../../../shared/messages";
import ClaimsCell from "./ClaimsCell";
import {SCOPE} from "../../../shared/messages";
import "./Claims.scss";

class ScopeItem extends Component {
    static propTypes = {
        id: PropTypes.number,
        displayFlexibleAttributes: PropTypes.bool,
        displayUserExtendedAttributes: PropTypes.bool,
        displayNonLdapEpicUsername: PropTypes.bool,
        extendedAttributes: PropTypes.object,
        updateScope: PropTypes.func,
        deleteScope: PropTypes.func,
        oidcScopeItem: PropTypes.object,
    }

    handleUpdateScopeName = (e) => {
        let updatedScope = {
            ...this.props.oidcScopeItem,
            "scopeName": e.target.value
        }
        this.props.updateScope(this.props.id, updatedScope)
    }
    handleUpdateClaimsInScope = (updatedCustomClaims) => {
        let updatedScope = {
            ...this.props.oidcScopeItem,
            "oidcCustomClaims": updatedCustomClaims
        }
        this.props.updateScope(this.props.id, updatedScope)
    }

    handleDeleteScope = () => {
        this.props.deleteScope(this.props.id, this.props.oidcScopeItem);
    }

    render() {
        return(
            <div>
                {
                    this.props.oidcScopeItem.isDefault
                    ? (
                        <div className="scope-name-title">
                            {this.props.oidcScopeItem.scopeName[0].toUpperCase()
                                + this.props.oidcScopeItem.scopeName.substring(1)}
                            {SCOPE}
                        </div>
                    ) : (
                        <div className="scope-name-table">
                            <table>
                                <tbody>
                                    <tr>
                                        <th>
                                            <div className="scope-name-input">
                                                <ClaimsCell
                                                    className="attributes-name-input form-control attributes-input"
                                                    onClaimUpdate={this.handleUpdateScopeName}
                                                    cellData={{
                                                        type: "scopeName",
                                                        value: this.props.oidcScopeItem.scopeName,
                                                        id: this.props.id,
                                                        placeholder: messageConstants.CUSTOM_SCOPE
                                                    }}/>
                                            </div>
                                        </th>
                                        <th>
                                            <button type="button" onClick={this.handleDeleteScope} className="attr-button">
                                                <span className="fa fa-minus btn-circle btn-minus"/>
                                                <span
                                                    className="attr-button-label">{messageConstants.BUTTON_REMOVE_SCOPE}</span>
                                            </button>
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )
                }
                <ClaimsTable
                    name="oidcCustomClaims"
                    updateClaimsInScope={this.handleUpdateClaimsInScope}
                    oidcCustomClaims={this.props.oidcScopeItem.oidcCustomClaims}
                    extendedAttributes={this.props.extendedAttributes}
                    displayUserExtendedAttributes={this.props.displayUserExtendedAttributes}
                    displayFlexibleAttributes={this.props.displayFlexibleAttributes}
                    displayNonLdapEpicUsername={this.props.displayNonLdapEpicUsername}
                    deleteClaimFromScope={this.handleDeleteClaimFromScope}/>
            </div>
        );
    }
}

export default ScopeItem;
